import Icon from '../../components/Icon.vue'

Icon.register({
  'regular/arrow-alt-circle-down': {
    width: 512,
    height: 512,
    paths: [
      {
        d: 'M256 8c137 0 248 111 248 248s-111 248-248 248-248-111-248-248 111-248 248-248zM256 456c110.5 0 200-89.5 200-200s-89.5-200-200-200-200 89.5-200 200 89.5 200 200 200zM224 140c0-6.6 5.4-12 12-12h40c6.6 0 12 5.4 12 12v116h67c10.7 0 16.1 12.9 8.5 20.5l-99 99c-4.7 4.7-12.3 4.7-17 0l-99-99c-7.5-7.6-2.2-20.5 8.5-20.5h67v-116z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/regular/arrow-alt-circle-down.js
// module id = 1687
// module chunks = 0